<template>
  <div
    :class="[
      'messageContainer', {
        outgoing: !isIncoming && type !== 'CHATBOT' && type !== 'AIAIBOT_FEEDBACK',
        incoming: (isIncoming && ['CHAT', 'FILE', 'YES_NO', 'CHECK_ACTIVITY', 'JOIN', 'button-group'].indexOf(type) >= 0) || isNotChatBotNotification(type, message),
        'with-padding': !['AIAIBOT', 'AIAIBOT_FEEDBACK'].includes(type)
      }]">
    <img :src="getSenderIcon(message, type)"
      :alt="getSenderScreenName(message)"
      class="message-picto"
      :class="{'message-picto-default': message.msgId < 0 || !message.msgId}"
      v-if="(['CHAT', 'FILE', 'YES_NO', 'CHECK_ACTIVITY'].indexOf(type) >= 0 && isIncoming) || isNotChatBotNotification(type, message)"
    >
    <div class="message" v-if="type === 'CHAT' || type === 'FILE'">
      <div class="content">
        <div class="smallArrow"></div>
        <template v-if="type === 'CHAT'">
          <div v-if="message.msgLabelKey" class="message-text" v-html="t(message.msgLabelKey)" v-linkified:options="{ linkAttributes: linkAttributes }" />
          <div v-else class="message-text" v-html="message.msgText" v-linkified:options="{ linkAttributes: linkAttributes }" />
          <div class="actions">
            <ChatButton
              v-for="action in actions"
              :key="action.label"
              :class="action.className"
              :label="t(action.label)"
              @click="action.callback(action)" />
          </div>
        </template>
        <Message-image
          v-if="type === 'FILE' && isImage(message.files[0])"
          :message="message"
          :file="message.files[0]"
          @imageRendered="onImageRendered"
        />
        <Message-file
          v-if="type === 'FILE' && !isImage(message.files[0])"
          :message="message"
          :file="message.files[0]"
        />
      </div>
    </div>
    <template v-if="['AIAIBOT', 'AIAIBOT_FEEDBACK'].includes(type)">
      <AiaiBotMessage :message="message" @scrollToEnd="$emit('scrollToEnd')" />
    </template>
    <div v-if="message.botStatus === 'CHATBOT_JOINED'" color="grey" class="notification">
      <div class="text"> {{ t('messages_join', {agent: 'Chatbot'}, null, false) }} </div>
      <div class="incoming-message-intro">
        <img :src="getSenderIcon(message, type)"
         :alt="getSenderScreenName(message)"
         class="message-picto style-incoming-message">
         <span class="incoming-message-title"> {{ t('messages_chattingWithBot') }} </span>
      </div>
    </div>
    <div v-if="message.botStatus === 'TO_KUBE' || message.botStatus === 'CHATBOT_LEFT'" color="grey" class="notification">
      <div v-if="this.getTimeUntilClosing === null" class="text" v-html="t('messages_leftOutOfServiceHours')"></div>
      <div v-else class="text">{{ t('messages_left', {agent: 'Chatbot'}) }}</div>
    </div>
    <div class="message" v-if="isNotChatBotNotification(type, message)">
      <div class="content">
        <div class="smallArrow"></div>
        <ChatBot :message="message" />
      </div>
    </div>
    <div v-if="type === 'YES_NO'" class="message">
      <div class="content">
        <div v-if="message.msgLabelKey" v-html="t(message.msgLabelKey)" v-linkified:options="{ linkAttributes: linkAttributes }" />
        <div v-else v-html="message.msgText" v-linkified:options="{ linkAttributes: linkAttributes }" />
        <div class="send-transcript">
          <ChatButton
            :disabled="conversationState === 'CONVERSATION_NEW' || transcriptProcessing"
            class="button left-button button-yes-no options notselected"
            :key="message.label"
            @click="yesSendTranscript()">{{t('yes')}}</ChatButton>
          <ChatButton
            :disabled="conversationState === 'CONVERSATION_NEW' || transcriptProcessing"
            class="button right-button button-yes-no options notselected"
            :key="message.label"
            @click="noEndConversation()">{{t('no')}}</ChatButton>
        </div>
      </div>
    </div>
    <div
      class="meta"
      v-if="isCustomerFlow &&
        isSystemMessage &&
        !isNotChatBotNotification(type, message) &&
        !['AIAIBOT', 'AIAIBOT_FEEDBACK', 'FINISH', 'AIAIBOT_INACTIVE_CLOSE'].includes(type)
      "
    >
      {{ t('messages_systemMessage') }}
    </div>
    <div class="meta" v-if="isNotChatBotNotification(type, message) && isCustomerFlow">
      {{ t('messages_chatbotMessage') }}
    </div>
    <div v-if="type === 'JOIN'" color="grey" class="notification">
      <div class="incoming-message-intro">
        <img :src="getSenderIcon(message, type)"
          :alt="getSenderScreenName(message)"
          class="message-picto style-incoming-message">
        <span class="incoming-message-title"> {{ t('messages_chattingWith', {agent: message.agentName || message.screenName}, null, false) }} </span>
       </div>
    </div>
    <div v-if="type === 'LEAVE'" color="grey" class="notification">
      <div class="text">
        {{ t('messages_agentLeft', { agent: message.agentName || message.screenName }, null, false) }}
      </div>
    </div>
    <div v-if="type === 'HANDOVER'" color="grey" class="notification">
      <div class="text">
        {{ t('messages_handover', {agentA: getLatestAgent.agentName || getLatestAgent.screenName, agentB: message.agentName || message.screenName}, null, false) }}
      </div>
    </div>
    <div v-if="type === 'FINISH'" color="grey" class="notification">
      <div class="text">
        {{ t('agent_ended_text', {agent: message.agentName || message.screenName}, null, false) }}
      </div>
    </div>
    <div v-if="type === 'AIAIBOT_FINISH'" color="grey" class="notification">
      <div class="text">
        {{ t('aiaibot_message_leave', { agent: message.agentName || message.screenName }) }}
      </div>
    </div>
    <div class="message" v-if="type === 'CHECK_ACTIVITY'">
      <div class="content">
        <div class="smallArrow"></div>
        <div class="message-text" v-html="t('check_activity_notification')"/>
      </div>
      <ChatButton
        class="sanitas-button sanitas-tertiary check-activity-action"
        :label="t('check_activity_action_yes')"
        :disabled="lastCheckActivityActiveMsg.msgId !== message.msgId"
        @click="setActivity({ senderId: message.senderId })"
      />
    </div>
    <div class="message" v-if="type === 'ENDUSER_IS_ACTIVE'">
      <div class="content">
        <div class="smallArrow"></div>
        <div class="message-text" v-html="t('check_activity_action_yes')"/>
      </div>
    </div>
    <div
      class="spacer"
      v-if="isIncoming &&
        !['AIAIBOT', 'AIAIBOT_FEEDBACK'].includes(type) &&
        ['JOIN', 'LEAVE'].indexOf(type) === -1
      "
    />
  </div>
</template>

<script>
import Vue from 'vue'
import { ref, onMounted } from '@vue/composition-api'
import { mapActions, mapGetters, mapState } from 'vuex'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import vueLinkify from 'vue-linkify'
import MessageFile from './message/File'
import MessageImage from './message/Image'
import ChatButton from './ChatButton'
import ChatBot from './chatbot/ChatBot'
import AiaiBotMessage from './aiaiBot/AiaiBotMessage'

export default {
  name: 'Message',
  components: {
    ChatButton,
    MessageImage,
    MessageFile,
    ChatBot,
    AiaiBotMessage
  },
  directives: {
    vueLinkify
  },
  props: ['image', 'message', 'type', 'isIncoming', 'actions'],

  setup () {
    const { $label: t } = useI36n()
    const linkAttributes = { target: '_blank', rel: 'noopener noreferrer' }

    const transcriptProcessing = ref(false)

    onMounted(() => {
      transcriptProcessing.value = false
    })

    return {
      t,
      linkAttributes,
      transcriptProcessing
    }
  },

  computed: {
    ...mapGetters('uistate', ['defaultIncomingIcon', 'defaultAgentScreenName', 'isCustomerFlow', 'chatbotIncomingIcon', 'webView', 'getTimeUntilClosing']),
    ...mapGetters('conversation', ['getLatestAgent']),
    ...mapState('uistate', ['conversationState']),
    ...mapState('conversation', ['conversation', 'user', 'lastCheckActivityActiveMsg']),
    isSystemMessage () {
      return this.isIncoming && (this.getSenderScreenName(this.message) === this.defaultAgentScreenName)
    },
    isChatbotMessage () {
      return this.type === 'CHATBOT'
    }
  },
  methods: {
    ...mapActions('conversation', ['setActivity']),
    getSenderIcon (message, type) {
      if (type === 'CHATBOT') {
        return this.chatbotIncomingIcon
      }
      return (message.senderId > 0) ? Vue.prototype.$chatApi.settings.baseUrl + '/profile/' + message.senderId + '/profilePicture' : this.defaultIncomingIcon
    },
    getSenderScreenName (message) {
      return message.agentName || message.screenName || this.defaultAgentScreenName
    },
    isImage (file) {
      return file.contentType.indexOf('image') > -1
    },
    isNotChatBotNotification (type, message) {
      return type === 'CHATBOT' && !['CHATBOT_JOINED', 'TO_KUBE', 'CHATBOT_LEFT'].includes(message.botStatus)
    },
    onImageRendered () {
      setTimeout(() => {
        this.$emit('scrollToEnd')
      }, 200) // must delay the event because of Firefox
    },
    yesSendTranscript () {
      this.transcriptProcessing = true
      this.$store.dispatch('conversation/transcriptUi')
    },
    async noEndConversation () {
      this.transcriptProcessing = true
      await this.$store.dispatch('conversation/archiveConversation')
      
      if (this.isCustomerFlow) {
        await this.$store.dispatch('uistate/setConversationState', 'CONVERSATION_ENDED')
      } else {
        await this.$store.dispatch('conversation/openRating')
      }
    }
  }
}
</script>

<style lang="postcss" scoped>
.messageContainer {
  display: flex;

  &.with-padding {
    padding: 7.5px 25px 7.5px 15px;
  }

  &.outgoing {
    flex-direction: column;
    align-items: flex-end;
  }
  &.outgoing, &.incoming {
    position: relative;
    z-index: 0;
  }
  &.incoming  {
    .full &, .customer & {
      flex-wrap: wrap;
      .meta {
        width: 100%;
        font-size: 11px;
        padding-top: 4px;
        padding-left: 67px;
        color: black;
     }
    }
  }
  .incoming-message-intro {
    display: flex;
    .incoming-message-title {
      width: 100%;
      display: flex;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      font-weight: bold;
      font-size: 15px;
    }
  }
  .message-picto {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 0 17px 0 0;
    background: white;
    align-self: flex-end;
    overflow: hidden;
    flex: none;
    border: 1px solid gainsboro;
    padding: 3px;
    &.style-incoming-message {
      width: 100px;
      height: 100px;
    }
  }
  .message-picto-default {
    background-color: white;
    border: 1px solid white;
  }
  .message {
    position: relative;
    width: 75%;
    height: 100%;
    min-width: 211px;
    display: flex;
    flex: inherit;
    flex-wrap: wrap;
    .meta {
      width: 100%;
      font-size: 11px;
      padding-left: 67px;
      padding-top: 4px;
      color: black;
    }
    .smallArrow {
      position: absolute;
      width: 0;
      height: 0;
      left: -11px;
      bottom: 7px;
      border-bottom: 7px white solid;
      border-left: 11px transparent solid;
    }
    .message-text {
      white-space: pre-line;
    }
    .check-activity-action {
      border-radius: 5px;
      width: 100%;
    }
    .content {
      background-color: white;
      position: relative;
      border-radius: 7px;
      padding: 10px;
      word-wrap: break-word;
      margin: auto auto auto 0;
      min-height: 30px;
      max-width: 100%;
      >>> a {
        display: inline;
        text-decoration: none;
        font-weight: 600;
        outline-style:none;
        box-shadow:none;
        border-color:transparent;
        &:hover {
          border: none;
        }
      }
      .actions {
        display: flex;
        flex-direction: column;
      }
      .send-transcript {
        display: flex;
        align-items: flex-start;

        .notselected {
          background-color: transparent;
          color: var(--tw-c-original-green);
        }

        .disabled:hover:not(.notselected), .disabled:not(.notselected) {
          color: white;
          background-color: var(--tw-c-original-green);
        }

        .disabled:hover {
          border: 1px solid var(--tw-c-original-green);
        }

        &:hover {
          cursor: pointer;
        }
      }
    }
  }
  &.outgoing {
    flex: initial;

    .smallArrow {
        left: inherit;
        right: -11px;
        border-bottom-color: #dbead1;
        border-left: 0;
        border-right: 11px transparent solid;
    }

    .meta {
      text-align: right;
    }

    .content {
      background-color: #dbead1;
      margin: auto 0 auto auto;
    }
  }
  .notification {
    font-family: 'Open Sans', sans-serif;
    font-size: 11px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.54;
    letter-spacing: normal;
    text-align: left;
    color: black;
    width: 100%;
  }

  .left-button {
    border-radius: 30px 0px 0px 30px;
  }

  .right-button {
    float: right;
    border-radius: 0px 30px 30px 0px;
  }

  .notselected {
    background-color: transparent;
    color: var(--tw-c-original-green);
  }

  .button-yes-no {
    border-style: solid;
    border-color: #5BAC26;
    border-width: 1px;
  }

  .disabledbutton {
    background-color: white;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .messageContainer {
    .message {
      .content {
        width: 100%;
      }
    }
  }
}
</style>
